import { SET_CONTACTS_FILTERS } from '../actions/filters';

const initialState = {
    searchText: ''
};

export default (state = initialState, action) => {
    switch (action.type) {
        case SET_CONTACTS_FILTERS: {
            return {
                ...state,
                searchText: action.payload.searchText
            };
        }

        default:
            return state;
    }
};
